export const initAccordion = () => {

  // ボタン取得
  const accordionBtns = document.querySelectorAll(".js-accordion-btn"); 
  // アコーディオンがなければ終了
  if (accordionBtns.length === 0) return;

  for (let i = 0; i < accordionBtns.length; i++) {
    const accordionBtn = accordionBtns[i];
    const btnText = accordionBtn.querySelector(".btn-text");
    const btnValue = btnText.dataset.page;
    const openText = `${btnValue}の目次を見る`;
    // 初期表示
    btnText.textContent = openText;

    accordionBtn.addEventListener("click",function(){

      this.classList.toggle("-click");
      // 前のコンテンツ
      const content = this.previousElementSibling;

      if (content.style.height) {
        content.style.height = null;
        btnText.textContent = `${btnValue}の目次を見る`;
      } else {
        content.style.height = content.scrollHeight + 'px';
        btnText.textContent = "目次を閉じる";
      }
    });
  }
};